// Function to close the Footer Nav list if the window is too narrow.
function toggleFooterNav() {
  const footerNavList = jQuery('#FooterSitemapCollapse');
  if (window.innerWidth < 752) {
    footerNavList.collapse('hide');
  } else {
    footerNavList.collapse('show');
  }
}

(function ($, Drupal) {
  Drupal.behaviors.halifax_section_nav = {
    attach: function () {
      const footerNav = jQuery('nav.c-footer-sitemap');
      const hasFooterNav = footerNav.length;
      if (hasFooterNav) {
        jQuery(document).ready(toggleFooterNav);
      }
    },
  };
})(jQuery, Drupal);
